<div mat-dialog-title>
	Message detail
</div>

<mat-dialog-content>
	<dl class="row mb-2 message-meta">
		<dt class="col-sm-3">To</dt>
		<dd class="col-sm-9">{{ message.toName }} &lt;{{ message.toAddress }}&gt;</dd>

		<dt class="col-sm-3">CC</dt>
		<dd class="col-sm-9">
			<span *ngIf="ccAddresses.length === 0" class="text-muted">—</span>
			<span *ngFor="let cc of ccAddresses; let last = last">{{ cc }}<span *ngIf="!last">, </span></span>
		</dd>

		<dt class="col-sm-3">Subject</dt>
		<dd class="col-sm-9">{{ message.subject }}</dd>

		<dt class="col-sm-3">Status</dt>
		<dd class="col-sm-9">
			{{ message.status }}
			<span *ngIf="message.deliveryMode !== 'Send'" class="text-muted">({{ message.deliveryMode }})</span>
		</dd>

		<dt class="col-sm-3" *ngIf="message.redirectedToAddress">Redirected to</dt>
		<dd class="col-sm-9" *ngIf="message.redirectedToAddress">{{ message.redirectedToAddress }}</dd>

		<dt class="col-sm-3" *ngIf="message.failureReason">Failure</dt>
		<dd class="col-sm-9 text-danger" *ngIf="message.failureReason">{{ message.failureReason }}</dd>

		<dt class="col-sm-3" *ngIf="message.bounceReason">Bounce</dt>
		<dd class="col-sm-9 text-danger" *ngIf="message.bounceReason">{{ message.bounceReason }}</dd>
	</dl>

	<label class="font-weight-bold mb-1">Body</label>
	<iframe class="message-body-frame" sandbox="allow-popups allow-popups-to-escape-sandbox" [srcdoc]="safeBody" title="Rendered notification body"></iframe>
</mat-dialog-content>

<mat-dialog-actions>
	<button class="btn btn-link" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>
